import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ActionBar } from '../../models';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-action-bar',
  templateUrl: './action-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgClass],
})
export class ActionBarComponent {
  @Input() actionBar!: ActionBar;

  constructor() {}
}
